import React, { useState } from "react";
import Eye from "../../../assets/svgs/Eye";
import Share from "../../../assets/svgs/Share";
import Trash from "../../../assets/svgs/Trash";
import Pencil from "../../../assets/svgs/Pencil";
import Edit from "../../../assets/svgs/Edit";

function Tr({ index, name, team, contacts }) {
  const [showActions, setShowActions] = useState(false);
  return (
    <tr className={`${index % 2 === 0 ? "bg-gray-100" : "bg-gray-50"}`}>
      <td className="text-center p-5 text-sm border-r-2">
        <p className="border-b-4 border-green-500 inline-block mx-auto">
          {name}
        </p>
      </td>
      <td className="text-center p-5 text-sm border-r-2">{team}</td>
      <td className="text-center px-5 py-5 text-sm border-r-2">
        <p className="text-gray-900 whitespace-no-wrap flex flex-col space-y-1">
          {contacts.map((c, i) => (
            <span key={i + " " + Math.random()}>{c}</span>
          ))}
        </p>
      </td>
      <td className="p-5 relative text-sm border-r-2">
        {showActions && (
          <>
            <div
              onClick={() => setShowActions(false)}
              className="fixed inset-0 bg-black bg-opacity-5 z-10"
            />
            <div className="absolute -top-16 right-32 w-32 z-50 bg-gray-100 shadow-xl rounded-md overflow-hidden">
              <button className="w-full text-xs flex space-x-1 p-2 items-center justify-start bg-gradient-to-tr from-pink-500 to-red-500 text-white">
                <Eye />
                <span>View Profile</span>
              </button>
              <button className="w-full hover:bg-gray-200 items-center text-xs flex space-x-1 p-2">
                <Share />
                <span>Share</span>
              </button>
              <button className="w-full hover:bg-gray-200 items-center text-xs flex space-x-1 p-2">
                <Edit />
                <span>Edit</span>
              </button>
              <button className="w-full hover:bg-gray-200 items-center text-xs flex space-x-1 p-2">
                <Trash />
                <span>Delate</span>
              </button>
            </div>
          </>
        )}
        <div className="w-full flex justify-center items-center">
          <button
            onClick={() => setShowActions((p) => !p)}
            className="w-8 h-8 flex items-center justify-center text-white bg-gradient-to-r from-[#FA4A6F] to-[#BA004F] rounded-full text-2xl"
          >
            <Pencil />
          </button>
        </div>
      </td>

      <td className="p-5 text-sm border-r-2">
        <div className="w-fullflex justify-center items-center">
          <button className="w-8 h-8 flex items-center justify-center text-white bg-gradient-to-r from-[#FA4A6F] to-[#BA004F] rounded-full text-2xl">
            +
          </button>
        </div>
      </td>
    </tr>
  );
}

const Table = () => {
  return (
    <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
      <div className="inline-block min-w-full shadow rounded-lg overflow-hidden">
        <table className="min-w-full leading-normal">
          <thead>
            <tr>
              <th className="px-5 py-5 border-b-2 border-gray-200 text-sm  font-semibold text-gray-600 tracking-wider">
                Employe Name
              </th>
              <th className="px-5 py-5 border-b-2 border-gray-200 text-sm  font-semibold text-gray-600 tracking-wider">
                Team
              </th>
              <th className="px-5 py-5 border-b-2 border-gray-200 text-sm  font-semibold text-gray-600 tracking-wider">
                Contact
              </th>
              <th className="px-5 py-5 border-b-2 border-gray-200 text-sm  font-semibold text-gray-600 tracking-wider">
                Termination
              </th>
              <th className="px-5 py-5 border-b-2 border-gray-200 text-sm text-transparent">
                Actionss
              </th>
            </tr>
          </thead>
          <tbody>
            <Tr
              name="Jane Cooper"
              team="Design Team"
              contacts={["Janecooper@gmail.co", "+91 917722967"]}
              index={1}
            />
            <Tr
              name="Jane Cooper"
              team="Design Team"
              contacts={["Janecooper@gmail.co", "+91 917722967"]}
              index={2}
            />
            <Tr
              name="Jane Cooper"
              team="Design Team"
              contacts={["Janecooper@gmail.co", "+91 917722967"]}
              index={3}
            />
            <Tr
              name="Jane Cooper"
              team="Design Team"
              contacts={["Janecooper@gmail.co", "+91 917722967"]}
              index={4}
            />
            <Tr
              name="Jane Cooper"
              team="Design Team"
              contacts={["Janecooper@gmail.co", "+91 917722967"]}
              index={5}
            />
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
